module.exports = __webpack_public_path__ + "img/icon_filter_b.977a9102.svg";